module.exports = "<svg class=\"jg-loading__container\" viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"jg-loading__circle\" cx=\"24\" cy=\"24\" r=\"20\"></circle></svg>"


//////////////////
// WEBPACK FOOTER
// ../~/@jg/styles/src/assets/icons/loading.svg
// module id = 859
// module chunks = 0